import styled from '@emotion/styled';

export const SitesTestContainer = styled.div`
  padding: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
  font-family: 'Lexend', sans-serif;
`;

export const SitesTestTitle = styled.h1`
  text-align: left;
  color: #333;
  margin: 0 0 1.5rem 0;
  font-size: 2rem;
  font-weight: 600;
`;

export const TriggerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5rem;
  color: #666;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 1.5rem 0;
`;

export const SitesTestTitleInline = styled.h1`
  text-align: left;
  color: #333;
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
`;

export const TabButton = styled.button<{ isActive: boolean }>`
  padding: 0.4rem 0.8rem;
  border: 1px solid ${props => (props.isActive ? '#007bff' : '#e1e5e9')};
  border-radius: 6px;
  font-size: 0.9rem;
  background: ${props => (props.isActive ? '#007bff' : 'white')};
  color: ${props => (props.isActive ? 'white' : '#333')};
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: ${props => (props.isActive ? '600' : '400')};
  position: relative;

  &:hover {
    border-color: #007bff;
    background: ${props => (props.isActive ? '#007bff' : '#f8f9fa')};
  }
`;

export const TabBadge = styled.span`
  position: absolute;
  top: -10px;
  right: -12px;
  background: #333;
  color: white;
  border-radius: 8px;
  width: 24px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0 4px;
`;

export const SitesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 1.5rem;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
`;

export const TableHeader = styled.thead`
  background: #f8f9fa;
`;

export const TableHeaderCell = styled.th`
  padding: 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #e1e5e9;
  font-size: 0.9rem;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  border-bottom: 1px solid #e1e5e9;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f8f9fa;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TableCell = styled.td`
  padding: 0.75rem;
  vertical-align: middle;
  font-size: 0.9rem;
`;

export const RowNumberCell = styled(TableCell)`
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  text-align: center;
  font-weight: 500;
  color: #666;
  padding: 0.75rem 0.5rem;
`;

export const LogoCell = styled(TableCell)`
  width: 50px;
  padding: 0.5rem 0.75rem;
`;

export const SiteLogo = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e1e5e9;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const SiteName = styled.div`
  font-weight: 600;
  color: #333;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
`;

export const SiteDescription = styled.div`
  color: #666;
  font-size: 0.8rem;
  line-height: 1.3;
  margin-top: 0.25rem;
`;

export const StatusBadge = styled.span<{ hasLogo: boolean }>`
  display: inline-block;
  padding: 0.15rem 0.5rem;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;

  background-color: ${props => (props.hasLogo ? '#d4edda' : '#f8d7da')};
  color: ${props => (props.hasLogo ? '#155724' : '#721c24')};
  border: 1px solid ${props => (props.hasLogo ? '#c3e6cb' : '#f5c6cb')};
`;
